var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#91C496",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#91C496",
  d: "M5 19v-.55l2.037-2.665H5.002V15h3.316v.55L6.28 18.216h2.035V19zM10.527 15v4H9.514v-4zM11.74 19v-4h1.731q.471 0 .813.176.344.174.53.486.186.31.186.723 0 .414-.19.724a1.25 1.25 0 0 1-.539.479q-.35.17-.83.17h-1.07v-.762h.881q.229 0 .383-.076a.54.54 0 0 0 .235-.213q.08-.139.08-.322a.6.6 0 0 0-.08-.32.53.53 0 0 0-.235-.212.9.9 0 0 0-.383-.074h-.5V19z"
})));
export default SvgZip;